<div class="main-card shadow-sm">
  <!-- Low Stock Table -->
  <div class="table-box">
    <div class="table-heading-row d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <fa-icon [icon]="faCircleExclamation" class="icon-red"></fa-icon>
        <span class="table-heading-text">Low Stock</span>
        <span class="count-badge badge-red">{{ lowStockCount | number }}</span>
      </div>
      @if (lowStockList.length > 4) {
        <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllLowStock(lowStockModal)">
          View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
        </button>
      }
    </div>

    <!-- Loader -->
    @if (loader) {
      <div class="text-center py-4">
        <app-loader [loadingIcon]="loader"></app-loader>
      </div>
    }

    <!-- Error -->
    @if (!loader && errMsg) {
      <div class="text-center py-3">
        <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
      </div>
    }
    
    <!-- Data -->
    @if (!loader && !errMsg) {
      @if (lowStockList.length > 0) {
        @for (item of lowStockList | slice:0:4; track item) {
          <div class="stock-row cursor-pointer" (click)="onRowClick(item)">
            <div class="flex-grow-1 min-width-0">
              <div class="td-top-text fw-smbold">{{ item.title }}</div>
              <div class="td-bottom-text">{{ item.details }} - {{item.companyName}}</div>
            </div>
            <span class="td-right-text text-red">
              {{ item.actionText }}
            </span>
          </div>
        }
      } @else {
        <div class="text-center py-3">
          <p class="text-muted mb-0 small fw-bold">No data found.</p>
        </div>
      }
    }
  </div>


</div>

<!-- Modal Template -->
<ng-template #lowStockModal let-modal>
  <div class="modal-header border-0 pb-0">
    <div class="d-flex align-items-center gap-2">
      <h5 class="fw-bold mb-0 main-heading">Low Stock Risks</h5>
      <span class="count-badge badge-red ms-1">{{ lowStockCount | number }}</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container" style="max-height: 60vh; overflow-y: auto;"
      infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
      [scrollWindow]="false" (scrolled)="onLowScroll()">

      @for (item of lowStockList; track item) {
        <div class="stock-row cursor-pointer" (click)="onRowClick(item)">
          <div class="flex-grow-1 min-width-0">
            <div class="td-top-text fw-smbold">{{ item.title }}</div>
            <div class="td-bottom-text">{{ item.details }} - {{item.companyName}}</div>
          </div>
          <span class="td-right-text text-red" >
            {{ item.actionText }}
          </span>
        </div>
      }

      @if (lowScroolLoader) {
        <div class="d-flex justify-content-center py-3">
          <app-loader [loadingIcon]="lowScroolLoader"></app-loader>
        </div>
      }

      @if (endOfLowResults && lowStockList.length > 0) {
        <div class="text-center py-3 text-muted small">
          End of results.
        </div>
      }
    </div>
  </div>
</ng-template>
